import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useSessionTimeout } from '../hooks/useSessionTimeout';
import { SessionTimeoutModal } from './SessionTimeoutModal';

interface SessionTimeoutWrapperProps {
  children: React.ReactNode;
}

export function SessionTimeoutWrapper({ children }: SessionTimeoutWrapperProps) {
  const { currentUser } = useAuth();
  const { showWarning, dismissWarning } = useSessionTimeout();

  return (
    <>
      {children}
      {currentUser && showWarning && (
        <SessionTimeoutModal onDismiss={dismissWarning} />
      )}
    </>
  );
}
